export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      trigger: {
        title: 'Trigger',
        type: 'string',
        enum: ['One', 'Two']
      }
    },
    dependencies: {
      trigger: {
        oneOf: [{
          properties: {
            trigger: {
              const: 'One'
            },
            one: {
              title: 'One Input',
              type: 'string'
            }
          }
        }, {
          properties: {
            trigger: {
              const: 'Two'
            },
            two: {
              title: 'Two Input',
              type: 'string'
            }
          }
        }]
      }
    }
  },
  uiSchema: {
    'dm:layout': [{
      type: 'text',
      text: 'Trigger Field',
      id: 'textTrigger'
    }, {
      type: 'field',
      id: 'trigger'
    }, {
      type: 'text',
      text: 'one goes here',
      id: 'textOne'
    }, {
      type: 'field',
      id: 'one'
    }, {
      type: 'text',
      text: 'two goes here',
      id: 'textTwo'
    }, {
      type: 'field',
      id: 'two'
    }, {
      type: 'text',
      text: 'the end',
      id: 'textEnd'
    }]
  },
  formData: {}
};